import { IconButton, SvgIcon, Tooltip } from '@mui/material';
import { RiDeleteBinLine } from '@remixicon/react';
import { useLanguage } from '../../../contexts/language';

export interface CrewTemplateActionsProps {
  isAdmin: boolean;
  isLoading: boolean;
  onDeleteRequest: () => void;
}

const CrewTemplateActions = ({
  isAdmin,
  isLoading,
  onDeleteRequest,
}: CrewTemplateActionsProps) => {
  const { t } = useLanguage();

  return (
    <div className="flex gap-4">
      {isAdmin && (
        <Tooltip title={t(`content.delete`)}>
          <IconButton onClick={onDeleteRequest} disabled={isLoading}>
            <SvgIcon component={RiDeleteBinLine} />
          </IconButton>
        </Tooltip>
      )}
    </div>
  );
};

export default CrewTemplateActions;
